module.exports = __webpack_public_path__ + "c42e7881a7601e80cb16c6c32047a888.png";